// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type {
  FirewallPolicyDraft,
  FirewallPolicyDraftsCreateOrUpdateOptionalParams,
  FirewallPolicyDraftsCreateOrUpdateResponse,
  FirewallPolicyDraftsDeleteOptionalParams,
  FirewallPolicyDraftsGetOptionalParams,
  FirewallPolicyDraftsGetResponse,
} from "../models/index.js";

/** Interface representing a FirewallPolicyDrafts. */
export interface FirewallPolicyDrafts {
  /**
   * Create or update a draft Firewall Policy.
   * @param resourceGroupName The name of the resource group.
   * @param firewallPolicyName The name of the Firewall Policy.
   * @param parameters Parameters supplied to the create or update Firewall Policy Draft operation.
   * @param options The options parameters.
   */
  createOrUpdate(
    resourceGroupName: string,
    firewallPolicyName: string,
    parameters: FirewallPolicyDraft,
    options?: FirewallPolicyDraftsCreateOrUpdateOptionalParams,
  ): Promise<FirewallPolicyDraftsCreateOrUpdateResponse>;
  /**
   * Delete a draft policy.
   * @param resourceGroupName The name of the resource group.
   * @param firewallPolicyName The name of the Firewall Policy.
   * @param options The options parameters.
   */
  delete(
    resourceGroupName: string,
    firewallPolicyName: string,
    options?: FirewallPolicyDraftsDeleteOptionalParams,
  ): Promise<void>;
  /**
   * Get a draft Firewall Policy.
   * @param resourceGroupName The name of the resource group.
   * @param firewallPolicyName The name of the Firewall Policy.
   * @param options The options parameters.
   */
  get(
    resourceGroupName: string,
    firewallPolicyName: string,
    options?: FirewallPolicyDraftsGetOptionalParams,
  ): Promise<FirewallPolicyDraftsGetResponse>;
}
